import React from "react";
import { Box, Tooltip } from "@material-ui/core";
import { capitalize, get } from "lodash";
import { CHECKIN_TYPE } from "Modules/Reports/constants";

const CheckinType = colProps => {
  const type = capitalize(
    CHECKIN_TYPE[get(colProps, "dataItem.checkInType", "")]
  );
  return (
    <td>
      <Tooltip title={type}>
        <Box ml={1.4}>{type}</Box>
      </Tooltip>
    </td>
  );
};

export default CheckinType;
